export default String.raw`
{% capture breadcrumbBase -%}{% include 'partials/common/absolute-base.html' -%}{% endcapture -%}
{% assign lookbook_data = config.Lookbook.Current -%}
{% assign link = config.Pages[25].Url | Replace: '^\./', '' -%}
{% assign isLookbookPage = false -%}
{% if page.PageId == config.DefinedPages.Lookbook.Id -%}
    {% assign isLookbookPage = true -%}
{% endif -%}
{% assign breadcrumbsSize = page.Breadcrumbs | Size -%}
{% assign lookbookTitle = page.MetaTitle | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign lookbookText = lookbook_data.Text | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% if breadcrumbsSize > 0 or isLookbookPage -%}
<script type="application/ld+json">
{
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
        {% for breadcrumb in page.Breadcrumbs -%}
            {% assign breadcrumbName = breadcrumb.Name | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
            {% assign breadcrumbUrl = breadcrumb.Url -%}
            {% if breadcrumbUrl == './' or breadcrumbUrl == '.' -%}
                {% assign breadcrumbUrl = '' -%}
            {% endif -%}
            {% assign breadcrumbUrl = breadcrumbUrl | Replace: '^\./', '' -%}
                {
                    "@type": "ListItem",
                    "position": {{forloop.index}},
                    "item": {
                        "@type": "WebPage",
                        "@id": "{{breadcrumbBase}}{{breadcrumbUrl}}",
                        "name": "{{breadcrumbName}}"
                    }
                }
                {% if isLookbookPage %}, {% break -%}{% elseif forloop.index != breadcrumbsSize -%},{% endif -%}
        {% endfor -%}
        {% assign lookbookPos = 1 -%}
        {% if breadcrumbsSize > 0 -%}
            {% assign lookbookPos = 2 -%}
        {% endif -%}
        {% if lookbook_data != null and isLookbookPage -%}
                {
                    "@type": "ListItem",
                    "position": {{lookbookPos}},
                    "item": {
                        "@type": "WebPage",
                        "@id": "{{breadcrumbBase}}{{link}}",
                        "name": "{{lookbookTitle}}"
                    }
                },
                {
                    "@type": "ListItem",
                    "position": {{lookbookPos | Plus: 1}},
                    "item": {
                        "@type": "WebPage",
                        "@id": "{{page.CanonicalLink}}",
                        "name": "{{lookbookText}}"
                    }
                }
        {% elseif lookbook_data == null and isLookbookPage -%}
                {
                    "@type": "ListItem",
                    "position": {{lookbookPos}},
                    "item": {
                        "@type": "WebPage",
                        "@id": "{{breadcrumbBase}}{{link}}",
                        "name": "{{lookbookTitle}}"
                    }
                }
        {% endif -%}
    ]
}
</script>
{% endif -%}
`